/* import __COLOCATED_TEMPLATE__ from './pix-button.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { warn } from '@ember/debug';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import PixButtonBase from './pix-button-base';
let PixButton = (_class = class PixButton extends PixButtonBase {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "text", 'pix-button');
    _defineProperty(this, "defaultModel", []);
    _initializerDefineProperty(this, "isTriggering", _descriptor, this);
    const isTriggerFunctionExistOnTypedifferentOfSubmit = this.args.type !== 'submit' && typeof this.args.triggerAction === 'function';
    const isTriggerFunctionExistOrNullOnTypeSubmit = this.args.type === 'submit' && (typeof this.args.triggerAction === 'function' || this.args.triggerAction === undefined || this.args.triggerAction === null);
    warn('PixButton: @triggerAction attribute should be a function', isTriggerFunctionExistOnTypedifferentOfSubmit || isTriggerFunctionExistOrNullOnTypeSubmit, {
      id: 'pix-ui.button.action.not-function'
    });
  }
  get isLoading() {
    warn('PixButton: @isLoading attribute should be a boolean.', [true, false, undefined, null].includes(this.args.isLoading), {
      id: 'pix-ui.button.is-loading.not-boolean'
    });
    return this.args.isLoading || this.isTriggering;
  }
  get type() {
    return this.args.type || 'button';
  }
  get loadingColor() {
    return this.args.loadingColor || this.args['loading-color'] || 'white';
  }
  get isDisabled() {
    warn('PixButton: @isDisabled attribute should be a boolean.', [true, false, undefined, null].includes(this.args.isDisabled), {
      id: 'pix-ui.button.is-disabled.not-boolean'
    });
    return this.isLoading || this.args.isDisabled ? 'true' : null;
  }
  get className() {
    return super.baseClassNames.join(' ');
  }
  async triggerAction(params) {
    if (this.isDisabled || this.type === 'submit' && !this.args.triggerAction) return;
    try {
      this.isTriggering = true;
      await this.args.triggerAction(params);
    } finally {
      this.isTriggering = false;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isTriggering", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "triggerAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerAction"), _class.prototype), _class);
export { PixButton as default };